import React, { Fragment } from 'react';
import { filter } from 'lodash';
import styled from 'styled-components';
import { push } from 'react-router-redux';
import { withLocalize } from 'react-localize-redux';
import { withRouter, Link } from 'react-router-dom';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Label } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { Symbol } from '../../uiStandard/event/symbol';


const Notification = (props) => {
  const { translate } = props;

  const hasUnreadMsg = filter(props.notifications, { deleted: false, read: false }).length > 0;

  const unreadMsgs = filter(props.notifications, { deleted: false, read: false }).length;

  const { path } = props.match;
  const isHomePage = path === '/';

  const symbolColor = () => {
    let color = '#fff';
    if (isHomePage) {
      if (props.navColor) {
        color = '#0094FB';
        return color;
      }
      color = '#fff';
      return color;
    }
    color = '#0094FB';
    return color;
  };

  return (
    <Fragment>
      <List className='globalHeader_list_item' data-item='notification'>
        <a
          onClick={() => {
            props.push('/notifications');
          }}
        >
          {
            hasUnreadMsg ? (<Symbol
              iconName='notification' notification={unreadMsgs} hasBorder={false}
              color={symbolColor()}
            />) : (
              <Symbol iconName='notification' hasBorder={false} color={symbolColor()} />
            )
          }
        </a>
      </List>
      <StyledList>
        <StyledLink to='/notifications' >
          {translate('form.label.message')}
          {
            hasUnreadMsg && (
              <Label color='teal' floating circular>
                {unreadMsgs}
              </Label>
            )
          }
        </StyledLink>
      </StyledList>

    </Fragment>
  );
};

const List = styled.li`
  @media only screen and (max-width: 768px) {
  display: none;
  }
`;

const StyledList = styled.li`
  display: none;
  justify-content:center; 
  align-items:center;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #666666;
  padding: 0.8em 0;

  :hover {
    color: #0095FA;
  }

  button {
    width: 50%;
  }

  @media only screen and (max-width: 387px) {
    li {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 768px) {
    display: flex;
}
`;

const StyledLink = styled(Link)`
  position: relative;
  width: fit-content;
  padding: 0 1em;

  .ui.circular.label {
    width: 20px;
    height: 20px;
    min-width: 1em ;
    min-height: 1em;
    font-size: 9px;
    color: #FFFFFF;
    background-color: #FF6666;
  }

  @media only screen and (max-width: 387px) {
    font-size: 14px;
  }
`;

export default compose(
  withLocalize,
  withRouter,
  connect(
    ({ notifications }) => ({ notifications }), { push }
  )
)(Notification);



// WEBPACK FOOTER //
// ./src/components/nav/notification.js